// 获取chatGPT回复
import { environment } from './index';

export const getChatGPTResultService = async ({ headers, data, extraData }: any) => {
    const { questionTag, isCreateQa, question, oldLucaAskChatId, abortChatSseRequest } = extraData;
    const controller = new AbortController();
    abortChatSseRequest.current = (reason: string) => controller.abort(reason);
    const response: Response = await fetch(`${environment.getApigateWay()}/athena/api/v1/front/luca-ask/chat-sse`, {
        method: 'POST',
        headers,
        body: JSON.stringify(data),
        signal: controller.signal,
    });
    const lucaRecordId = response.headers.get('Luca-Record-Id')!;
    const newestLucaAskChatId = response.headers.get('Luca-Ask-Chat-Id')!;
    const userRecordId = response.headers.get('User-Record-Id')!;
    // 是否是最后一个追问
    const isLastAskAgain = response.headers.get('Last-Ask-Again')!;
    const botChatIdOfStream = response.headers.get('Bot-Chat-Id')!;
    // 需要更新用户提问记录Id 需满足 “非functioncall 且 有返回用户提问的记录id”;
    const needUpdateUserRecordId = !!(data.role !== 'function' && userRecordId);
    // 需要问题总结 需满足 “问题未总结过 且 有返回lucaAskChatId 且 非functioncall 且 非请继续 且 非重试”
    const needRefineProblem = Boolean(
        questionTag !== 1 && newestLucaAskChatId && data.role !== 'function' && !data.isContinue && !data.retryType
    );
    // 需要在AI回复后追加“猜你想问” 需满足 “需要更新用户提问记录Id 且 删除用户提问内容（走上传图片OCR搜题流程）”
    const needCreateGuessYouAsk = needUpdateUserRecordId || data.bizType === 1;
    // 需要在AI回复后追加“学科搜索” 需满足 “需问题总结 且 不走上传图片OCR搜题流程”
    const needCreateSubjectSearch = needRefineProblem && data.bizType !== 1;
    return {
        isCreateQa,
        question,
        newestLucaAskChatId: newestLucaAskChatId || oldLucaAskChatId,
        userRecordId,
        lucaRecordId,
        isLastAskAgain,
        botChatIdOfStream,
        needUpdateUserRecordId,
        needCreateGuessYouAsk,
        needRefineProblem,
        needCreateSubjectSearch,
        reader: response.body!.getReader(),
    };
};

// 解码流
export const decodeStream = (reader: any) => {
    return new TextDecoder('utf-8').decode(reader, { stream: true });
};
